import React, {Component} from 'react';
import {Col, Nav, NavItem, NavLink, Row, TabContent, TabPane, UncontrolledTooltip} from "reactstrap";
import {validateComponent, validateField} from "../../../common/validation";
import Table from "../../../components/Table/Table";
import {request} from "../../../helper/APIUtils";
import {deepCopyObject, prefixTypeName, showAxiosError} from "../../../helper/helper";
import Select from "../../../local_node_modules/react-select"
import Alert from "react-s-alert";
import classnames from "classnames";
import emailMask from "text-mask-addons/dist/emailMask";
import MaskedInput from "react-text-mask";
import {EntegratorConf, VirtualHost} from "../../../constants";
import {showOnlySmart, showOwnInbox} from "../../../helper/permission";

class UserForm extends Component {

    constructor(props) {
        super(props);

        this.state = {
            error: {},
            mode: 'create',
            key: Math.random().toString(36),
            customerBranchList: [{
                numberOfElements: 0
            }],
            customerBranchListForEdit: [],
            residueBranchMap: {},
            branchMap: {},
            selectedAliasList: [],
            page: 0,
            size: 10,
            manual: false,
            loading: false,
            authRoles: [],
            selectedRole: null,
            activeTab: '1',
            aliasList: [],
            customerVknTckn: null,
            arrangedUserAliasList: [],
            selectedCustomerVknTckn: null,
            user: {
                admin: false,
                firstName: null,
                lastName: null,
                username: null,
                email: null,
                roleId: null,
                branchList: [],
                userAliasList: [],
                active: true,
            },
            prefixCodes: [],
            selectedPrefixCodes: [],
            isMobile: window.innerWidth > 991 ? false : true
        };

        this.validateClass = this.validateClass.bind(this);
        this.validateComponent = this.validateComponent.bind(this);
        this.validateField = this.validateField.bind(this);
        this.validateMessage = this.validateMessage.bind(this);
        this.toggleSelectedRow = this.toggleSelectedRow.bind(this);
        this.saveUser = this.saveUser.bind(this);
        this.fetchRoleList = this.fetchRoleList.bind(this);
        this.onRoleChange = this.onRoleChange.bind(this);
        this.clearForm = this.clearForm.bind(this);
        this.cancelProcess = this.cancelProcess.bind(this);
        this.onCheckAdmin = this.onCheckAdmin.bind(this);
        this.arrangeAliasList = this.arrangeAliasList.bind(this);
        this.onAliasChange = this.onAliasChange.bind(this);
        this.toggle = this.toggle.bind(this);
        this.onChangeSelectedCustomer = this.onChangeSelectedCustomer.bind(this);
        this.fetchBranchListForCEdit = this.fetchBranchListForCEdit.bind(this);
        this.onHasPrefixCodeChange = this.onHasPrefixCodeChange.bind(this);
        this.onHasXsltChange = this.onHasXsltChange.bind(this);
        this.onShowOwnDocumentsChange = this.onShowOwnDocumentsChange.bind(this);
        this.arrangePrefixCodes = this.arrangePrefixCodes.bind(this);
        this.onPrefixCodeChange = this.onPrefixCodeChange.bind(this);
        this.getPrefixCodes = this.getPrefixCodes.bind(this);
        this.onCheckActive = this.onCheckActive.bind(this);
        this.onAddDraftWatermarkChange = this.onAddDraftWatermarkChange.bind(this);
        this.fetchBranchListForC = this.fetchBranchListForC.bind(this);
        this.removeBranch = this.removeBranch.bind(this);
        this.addBranch = this.addBranch.bind(this);
        this.fetchBranchToAdd = this.fetchBranchToAdd.bind(this);
        this.onShowAssignInbox = this.onShowAssignInbox.bind(this);
        this.onShowVatProccesing = this.onShowVatProccesing.bind(this);
    }

    componentDidMount() {
        this.arrangeAliasList();
        this.fetchRoleList();
        this.arrangePrefixCodes();
        if (this.props.mode !== "edit") {
            this.fetchBranchListForC();
        } else {
            this.fetchBranchListForCEdit();
            this.fetchBranchToAdd();
        }


        if (this.props.selectedUser) {
            let selectedUser = deepCopyObject(this.props.selectedUser);
            let selectedAliasList = deepCopyObject(this.state.selectedAliasList);

            !!selectedUser.userAliasList && selectedUser.userAliasList.map(ua => {
                selectedAliasList.push(ua.alias.recordId);
            });

            let customerVknTckn = this.props.customerVknTckn ? this.props.customerVknTckn : null;

            this.setState({
                mode: this.props.mode,
                selectedRole: selectedUser.roleId && selectedUser.roleId.recordId,
                branchMap: this.props.branchMap,
                user: selectedUser,
                selectedAliasList,
                initialUserAliasList: selectedUser.userAliasList,
                customerVknTckn
            })
        }
    }

    validateField(e) {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength;
        let value = e.target.value;
        let result = validateField(rule, boundary, value);
        let error = this.state.error;
        error = Object.assign(error, {[id]: result});
        this.setState({error});
    }

    validateClass(id) {
        let error = this.state.error;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    validateMessage(id) {
        let error = this.state.error;
        return (error[id] === undefined ? '' : (error[id].message));
    }

    validateComponent() {
        let result = validateComponent(this);
        this.setState({
            error: result.error
        });
        return result
    }


    fetchRoleList() {
        let authRoles = [];
        let newRole1 = {};
        newRole1.recordId = 1;
        newRole1.roleName = "ADMİN KULLANICI";
        authRoles.push(newRole1);
        let newRole2 = {};
        newRole2.recordId = 2;
        newRole2.roleName = "NORMAL KULLANICI";
        authRoles.push(newRole2);
        if (this.props.currentUser.isEntegrator) {
            let newRole3 = {};
            newRole3.recordId = 3;
            newRole3.roleName = "ÇAĞRI MERKEZİ";
            authRoles.push(newRole3);
        }
        if (this.props.currentUser.isEntegrator && ["smart", "kolaysoft"].includes(VirtualHost.conf.resourcePrefix)) {
            let newRole4 = {};
            newRole4.recordId = 4;
            newRole4.roleName = "BAYİ SORUMLUSU";
            authRoles.push(newRole4);
            let newRole5 = {};
            newRole5.recordId = 5;
            newRole5.roleName = "BELGE DURUMU";
            authRoles.push(newRole5);
        }
        this.setState({authRoles});
    }

    onChangeUser(e) {
        if (e.target.name === "email") e.target.value = e.target.value.replaceAll(/[ÜĞŞİÇÖğıüşöç]/g, "")
        if (e.target.name === "username" && e.target.value.includes(' '))
            return;
        let {user} = this.state;
        user[e.target.name] = e.target.value;
        this.setState({user});
    }

    toggleSelectedRow(row) {
        let user = deepCopyObject(this.state.user);
        let customerBranchList = this.props.mode === "edit" ? deepCopyObject(this.state.customerBranchListForEdit) : deepCopyObject(this.state.customerBranchList.content);
        let branchMap = deepCopyObject(this.state.branchMap);
        let residueBranchMap = deepCopyObject(this.state.residueBranchMap);
        let userBranchList = user.branchList;

        if (row.selected) {

            if (Object.keys(branchMap).includes(row.recordId.toString())) {
                userBranchList.map(ub => {
                    if (ub.recordId === branchMap[row.recordId].recordId) {
                        userBranchList.splice(userBranchList.indexOf(ub), 1)
                    }
                });
                residueBranchMap[row.recordId] = branchMap[row.recordId];
                delete branchMap[row.recordId];
            } else {
                userBranchList.map(ub => {
                    if (ub.branch && ub.branch === row.recordId) {
                        userBranchList.splice(userBranchList.indexOf(ub), 1);

                        customerBranchList.map(cb => {
                            if (cb.recordId === row.recordId) {
                                cb.selected = false;
                            }
                        })
                    }
                })
            }

            customerBranchList.map(cb => {
                if (cb.recordId === row.recordId) {
                    cb.selected = false;
                }
            });

            if (this.props.mode === "edit") {
                this.setState({
                    customerBranchList,
                });
            } else {
                let temp = deepCopyObject(this.state.customerBranchList);
                temp.content = customerBranchList;
                this.setState({
                    customerBranchList: temp
                });
            }
            this.setState({
                residueBranchMap,
                branchMap,
                user
            });

        } else {

            if (Object.keys(residueBranchMap).length) {

                let found = false;
                for (let rb in residueBranchMap) {

                    if (row.recordId.toString() === rb) {

                        found = true;

                        userBranchList.push(residueBranchMap[rb])
                        branchMap[rb] = residueBranchMap[rb]

                        customerBranchList.map(cb => {
                            if (cb.recordId.toString() === rb) {
                                cb.selected = true;
                            }
                        });
                        delete residueBranchMap[rb];
                    }
                }

                if (!found) {
                    let newBranch = {};
                    newBranch.branch = row.recordId;
                    userBranchList.push(newBranch);

                    customerBranchList.map(cb => {
                        if (cb.recordId === row.recordId) {
                            cb.selected = true;
                        }
                    })
                }

            } else {
                let newBranch = {};
                newBranch.branch = row.recordId;
                userBranchList.push(newBranch);

                customerBranchList.map(cb => {
                    if (cb.recordId === row.recordId) {
                        cb.selected = true;
                    }
                })
            }

            if (this.props.mode === "edit") {
                this.setState({
                    customerBranchList,
                });
            } else {
                let temp = deepCopyObject(this.state.customerBranchList);
                temp.content = customerBranchList;
                this.setState({
                    customerBranchList: temp
                });
            }
            this.setState({
                residueBranchMap,
                branchMap,
                user
            });
        }
    }

    saveUser() {

        let validity = this.validateComponent();

        if (validity.valid && this.state.user.branchList.length > 0) {

            let user = deepCopyObject(this.state.user);
            let customerVknTckn = deepCopyObject(this.state.customerVknTckn);
            let selectedAliasList = deepCopyObject(this.state.selectedAliasList);
            let selectedPrefixCodesMaps = deepCopyObject(this.state.selectedPrefixCodes);
            let prefixCodeList = [];
            selectedPrefixCodesMaps.map(p => prefixCodeList.push(p.value));
            let userAliasList = [];

            !!selectedAliasList && selectedAliasList.map(sa => {
                sa.value ? userAliasList.push(sa.value) : userAliasList.push(sa)
            });

            let createUserPayload = {
                user,
                userAliasList,
                customerVknTckn,
                prefixCodeList
            };

            let regex = new RegExp(/[şŞıİçÇöÖüÜĞğ]/g);
            if (user.username.match(regex) !== null) {
                Alert.error('Kullanıcı adı türkçe karakter içeremez.', {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000,
                    html: false
                });
            } else {
                this.props.saveUser(createUserPayload);
                this.clearForm();
                this.cancelProcess();
            }
        } else {
            let user = deepCopyObject(this.state.user);

            if (user.branchList.length === 0) {
                Alert.error('Kullanıcı için şube seçiniz.', {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000,
                    html: false
                });
            } else {
                Alert.error('Hatalı alanlar var.', {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000,
                    html: false
                });
            }
        }
    }

    onRoleChange(e) {
        this.setState({
            selectedRole: e.value,
            user: {
                ...this.state.user,
                roleId: {recordId: e.value}
            }
        })
    }

    clearForm() {
        this.setState({
            key: Math.random().toString(36),
            selectedRole: null,
            user: {
                firstName: null,
                lastName: null,
                username: null,
                email: null,
                roleId: null,
                branchList: []
            }
        })
    }

    cancelProcess() {
        this.props.cancelProcess();
    }

    onUsernameBlur(e) {
        this.validateField(e);
        if (!!this.state.user.username) {
            let payload = {
                user: deepCopyObject(this.state.user)
            };
            if (this.props.mode === 'edit') {
                if (this.props.selectedUser !== null && this.state.user.username !== this.props.selectedUser.username) {
                    if (this.props.module === 'userList') {
                        this.checkIfUsernameExists(payload);
                    } else if (this.props.module === 'cUserList') {
                        payload.customerVknTckn = deepCopyObject(this.state.customerVknTckn)
                        this.checkIfUsernameExists(payload);
                    }
                }
            } else {
                if (this.props.module === 'userList') {
                    this.checkIfUsernameExists(payload);
                } else if (this.props.module === 'cUserList') {
                    payload.customerVknTckn = deepCopyObject(this.state.customerVknTckn)
                    this.checkIfUsernameExists(payload);
                }
            }
        }
    }

    checkIfUsernameExists(value) {
        let self = this;
        const data = value;
        let params = {
            url: `/user/findByUsername`,
            data: data,
            method: 'post'
        };
        request(params).then(function (response) {
            if (response.data) {
                let tUserName = {
                    valid: false,
                    message: "Bu Kullanıcı Adı Zaten Mevcut"
                };
                let error = deepCopyObject(self.state.error);
                error.tUserName = tUserName;
                self.setState({
                    error
                });
                Alert.error('Bu Kullanıcı Adı Zaten Mevcut', {
                    html: true,
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                })
            }
        })
            .catch(function (error) {
                showAxiosError(error);
            });
    }

    onCheckAdmin() {
        let admin = !deepCopyObject(this.state.user.admin);
        if (admin) {
            let error = deepCopyObject(this.state.error);
            if (error['tRole']) {
                delete error['tRole']
            }
            this.setState({
                error,
                selectedRole: null,
                user: {
                    ...this.state.user,
                    roleId: {recordId: 1},
                    admin,
                    showAssignInbox: 1
                }
            })
        } else {
            this.setState({
                selectedRole: null,
                user: {
                    ...this.state.user,
                    roleId: null,
                    admin,
                    showAssignInbox: 0
                }
            })
        }
    }

    onHasPrefixCodeChange(e) {
        this.setState({
            user: {
                ...this.state.user,
                hasPrefixCode: e.target.checked ? 1 : 0
            }
        })
    }

    onHasXsltChange(e) {
        this.setState({
            user: {
                ...this.state.user,
                hasXslt: e.target.checked ? 1 : 0
            }
        })
    }

    onShowOwnDocumentsChange(e) {
        this.setState({
            user: {
                ...this.state.user,
                showOwnDocuments: e.target.checked ? 1 : 0
            }
        })
    }


    arrangeAliasList() {
        let aliasList = deepCopyObject(this.state.aliasList);
        let alProp = deepCopyObject(this.props.aliasList);

        if (alProp) {
            alProp.map(a => {
                let found = false;
                !!aliasList && aliasList.map(alias => {
                    if (alias.value === a.recordId) {
                        found = true;
                    }
                });
                if (!found) {
                    let alias = {};
                    const cancelFlag = (a.actionType === 'C' && a.processState === 500 && a.processResult === 1300 && !a.gibRegistrationState);
                    alias.value = a.recordId;
                    alias.style = {color: (cancelFlag ? '#FF0000' : '#007eff')}
                    if (!!a.workScopecode) {
                        alias.label = a.service.ublCode + ': ' + a.workScopecode + (cancelFlag ? "(İPTAL)" : "");
                    } else if (!a.workScopecode) {
                        alias.label = a.service.ublCode + (cancelFlag ? "(İPTAL)" : "")
                    }
                    aliasList.push(alias)
                }
            })
        }

        this.setState({aliasList})
    }

    onCheckActive() {
        let active = !deepCopyObject(this.state.user.active);
        this.setState({
            user: {
                ...this.state.user,
                active
            }
        })
    }

    async arrangePrefixCodes() {
        await this.getPrefixCodes();
        let selectedPrefixCodes = deepCopyObject(this.state.selectedPrefixCodes);
        let prefixCodes = deepCopyObject(this.state.prefixCodes);
        let prefixCodeForDDL = [];
        let selectedPrefixCodeForDDL = [];

        if (selectedPrefixCodes) {
            selectedPrefixCodes.map(s => {
                let prefixCode = {};
                prefixCode.value = s.recordId;
                prefixCode.label = s.key + "(" + prefixTypeName(s.type) + ")";
                prefixCode.style = {color: '#007eff'};
                selectedPrefixCodeForDDL.push(prefixCode);
            })
        }

        if (prefixCodes) {
            prefixCodes.map(s => {
                let prefixCode = {};
                prefixCode.value = s.recordId;
                prefixCode.label = s.key + "(" + prefixTypeName(s.type) + ")";
                prefixCode.style = {color: '#007eff'};
                prefixCodeForDDL.push(prefixCode);
            })
        }

        this.setState({prefixCodes: prefixCodeForDDL, selectedPrefixCodes: selectedPrefixCodeForDDL})
    }

    toggle(tab) {

        this.setState({
            activeTab: tab
        })
    }

    onAliasChange(data) {
        this.setState({selectedAliasList: data})
    }

    onPrefixCodeChange(data) {
        this.setState({selectedPrefixCodes: data})
    }

    async onChangeSelectedCustomer(e) {
        this.setState({
            customerVknTckn: e.value,
            recordId: e.recordId,
            user: {
                admin: false,
                firstName: null,
                lastName: null,
                username: null,
                email: null,
                roleId: null,
                branchList: [],
                userAliasList: []
            }
        })

        await this.getAliasListByCustomer(e);
        await this.arrangeAliasListForC();
        await this.fetchBranchListForC(undefined, undefined, this.state.page, this.state.size);
        await this.arrangePrefixCodes();
    }

    async getAliasListByCustomer(item) {
        let self = this;
        let params = {
            url: `/user/getAliasListByCustomer`,
            method: 'post',
            data: item.value
        };
        let rawAliasListForC = null;
        await request(params).then(function (response) {
            rawAliasListForC = response.data;
            return rawAliasListForC;
        }).catch(function (error) {
            showAxiosError(error);
        });
        self.setState({rawAliasListForC})
    }

    arrangeAliasListForC() {
        let aliasList = [];
        let alProp = deepCopyObject(this.state.rawAliasListForC);

        if (alProp) {
            alProp.map(a => {
                let found = false;
                !!aliasList && aliasList.map(alias => {
                    if (alias.value === a.recordId) {
                        found = true;
                    }
                });
                if (!found && !!a.workScopecode) {
                    let alias = {};
                    alias.value = a.recordId;
                    alias.label = a.workScopecode;
                    aliasList.push(alias)
                }
            })
        }

        this.setState({aliasList})
    }

    async fetchBranchListForC(accessor, direction, page, size) {
        let self = this;
        let user = deepCopyObject(self.state.user);
        let data = self.state.recordId === undefined || self.state.recordId === null ? (self.props.mode === "edit" ? self.props.selectedUser.recordId : -1) : self.state.recordId;
        let params = {
            url: `/user/fetchCustomerBranchesForC?page=` + page + `&size=` + size,
            method: 'post',
            data: data
        };
        user.branchList = [];
        self.setState({user});
        let customerBranchList = null;
        await request(params).then(function (response) {
            let customerBranchListResp = response.data;
            customerBranchListResp.content.map(cb => {
                cb.selected = false;
            });
            customerBranchList = customerBranchListResp;
            return customerBranchList;
        }).catch(function (error) {
            showAxiosError(error);
        });
        self.setState({
            customerBranchList
        })
    }

    async fetchBranchListForCEdit(accessor, direction, page, size) {
        let self = this;
        let data = self.state.recordId === undefined || self.state.recordId === null ? self.props.selectedUser.recordId : self.state.recordId;
        let params = {
            url: `/user/fetchCustomerBranchesForCEdit?page=` + page + `&size=` + size,
            method: 'post',
            data: data
        };
        await request(params).then(function (response) {
            let customerBranchListForEdit = response.data;

            customerBranchListForEdit.map(cb => {
                cb.selected = Object.keys(self.state.branchMap).includes(cb.recordId.toString());
            });
            self.setState({
                    customerBranchListForEdit: customerBranchListForEdit
                }
            )
        })
            .catch(function (error) {
                showAxiosError(error);
            });
    }

    selectStyle(item) {
        let error = deepCopyObject(this.state.error);
        if (error[item] === undefined || error[item].valid) {
            return null;
        } else {
            return {backgroundColor: '#f8f8f8', borderColor: '#ffcfcf'}
        }
    }

    async getPrefixCodes() {
        let self = this;
        let userId = this.props.mode === "edit" && !!this.props.selectedUser && this.props.selectedUser.recordId;
        let customerVknTckn = this.props.mode === "create" && this.state.customerVknTckn;
        let url = "/user/getPrefixCodes?type=" + this.props.module;
        if (userId)
            url += '&userId=' + userId;
        else if (customerVknTckn)
            url += '&customerVknTckn=' + customerVknTckn;

        let params = {
            url: url,
            method: 'get'
        };

        let content = {
            prefixCodes: [],
            selectedPrefixCodes: []
        };
        await request(params).then(function (response) {
                if (response && response.data) {
                    if (response.data.prefixCodes)
                        content.prefixCodes = response.data.prefixCodes;

                    if (response.data.selectedPrefixCodes)
                        content.selectedPrefixCodes = response.data.selectedPrefixCodes;

                    return content;
                }
            }
        ).catch(function (error) {
            showAxiosError(error);
        });

        self.setState({prefixCodes: content.prefixCodes, selectedPrefixCodes: content.selectedPrefixCodes});
    }

    onAddDraftWatermarkChange(e) {
        this.setState({
            user: {
                ...this.state.user,
                addDraftWatermark: e.target.checked ? 1 : 0
            }
        })
    }

    removeBranch(row) {
        let user = deepCopyObject(this.state.user);
        let userBranchList = user.branchList;
        let customerBranchListForAdding = deepCopyObject(this.state.customerBranchListForAdding);
        let customerBranchListForEdit = deepCopyObject(this.state.customerBranchListForEdit);
        let found = false;

        row.selected = false;
        customerBranchListForAdding.push(row);

        customerBranchListForEdit.map((cb, index) => {
            if (cb.recordId === row.recordId) {
                customerBranchListForEdit.splice(index, 1);

            }
        })

        userBranchList.map((bl, index) => {
            if (bl.branch && bl.branch === row.recordId) {
                userBranchList.splice(index, 1);
                found = true;
            }
        })

        if (!found) {
            let rowBranches = [];
            row.branchList.map(branch => {
                rowBranches[branch.recordId] = branch.recordId;
            });

            userBranchList.map((bl, index) => {
                if (rowBranches[bl.recordId] === bl.recordId) {
                    userBranchList.splice(index, 1);
                }
            })
        }

        user.branchList = userBranchList;

        this.setState({customerBranchListForAdding, customerBranchListForEdit, user});
    }

    addBranch(row) {
        let user = deepCopyObject(this.state.user);
        let userBranchList = user.branchList;
        let customerBranchListForAdding = deepCopyObject(this.state.customerBranchListForAdding);
        let customerBranchListForEdit = deepCopyObject(this.state.customerBranchListForEdit);

        row.selected = true;
        customerBranchListForEdit.push(row);

        let newBranch = {};
        newBranch.branch = row.recordId;
        userBranchList.push(newBranch);

        customerBranchListForAdding.map((cb, index) => {
            if (cb.recordId === row.recordId) {
                customerBranchListForAdding.splice(index, 1);
            }
        })
        this.setState({customerBranchListForAdding, customerBranchListForEdit, user});
    }

    async fetchBranchToAdd() {
        let self = this;
        let data = self.state.recordId === undefined || self.state.recordId === null ? self.props.selectedUser.recordId : self.state.recordId;
        let params = {
            url: `/user/fetchCustomerBranchesForAdding`,
            method: 'post',
            data: data
        };
        await request(params).then(function (response) {
            let customerBranchList = response.data;
            let customerBranchListForAdding = [];

            customerBranchList.map(cb => {
                if (!Object.keys(self.state.branchMap).includes(cb.recordId.toString())) {
                    customerBranchListForAdding.push(cb);
                }
            });
            self.setState({customerBranchListForAdding: customerBranchListForAdding})
        })
            .catch(function (error) {
                showAxiosError(error);
            });
    }

    onShowAssignInbox(e) {
        this.setState({
            user: {
                ...this.state.user,
                showAssignInbox: e.target.checked ? 1 : 0
            }
        })
    }

    onShowVatProccesing(e) {
        this.setState({
            user: {
                ...this.state.user,
                showVatProccessing: e.target.checked ? 1 : 0
            }
        })
    }

    render() {
        const {isMobile} = this.state;
        const {customerBranchList} = this.state;
        const {customerBranchListForEdit} = this.state;

        const columns = [
            {
                Header: "",
                title: "Şubeyi Seç",
                accessor: "recordId",
                sortable: false,
                Cell: (row) => (
                    <input type="checkbox" checked={row.selected} onChange={(e) => this.toggleSelectedRow(row)}/>)
            },
            {
                Header: "Adres Adı",
                accessor: "branchName",
                sortable: false,
            },
            {
                Header: "İlçe",
                accessor: "citySubdivisionName",
                sortable: false,
            },
            {
                Header: "Şehir",
                accessor: "city",
                sortable: false,
            },
            {
                Header: "Telefon",
                accessor: "phone",
                sortable: false,
            },
            {
                Header: "E-posta",
                accessor: "email",
                sortable: false,
            },
            {
                Header: "Web Sitesi",
                accessor: "webSite",
                sortable: false,
            }
        ];

        const columnsForEdit = [
            {
                Header: "Adres Adı",
                title: "Adres Adı",
                accessor: "branchName",
                sortable: false,
            },
            {
                Header: "İlçe",
                title: "İlçe",
                accessor: "citySubdivisionName",
                sortable: false,
            },
            {
                Header: "Şehir",
                title: "Şehir",
                accessor: "city",
                sortable: false,
            },
            {
                Header: "Telefon",
                title: "Telefon",
                accessor: "phone",
                sortable: false,
            },
            {
                Header: "E-posta",
                title: "E-posta",
                accessor: "email",
                sortable: false,
            },
            {
                Header: "Web Sitesi",
                title: "Web Sitesi",
                accessor: "webSite",
                sortable: false,
            },
            {
                Header: "İşlemler",
                title: "İşlemler",
                accessor: "webSite",
                sortable: false,
                Cell: (row) => (
                    row.selected ?
                        <button className='simpleButton trash'
                                onClick={() => this.removeBranch(row)}/>
                        :

                        <button className='simpleButton add'
                                onClick={() => this.addBranch(row)}/>
                )
            }
        ];

        return (
            <div key={this.state.key}>

                <div className='card-header'>
                    <h4 className="card-title">{this.state.mode === 'create' ? 'Yeni Kullanıcı Oluştur' : 'Kullanıcı Düzenle'}</h4>
                </div>

                <div className="card-body">
                    <div className="FormRenk col-sm-12">

                        {(this.props.module === 'cUserList' && this.state.mode === 'create') &&
                            <div className='col-sm-12 row' style={{margin: '0 0 40px -16px'}}>
                                <div className="col-sm-2">
                                    <label className='col-form-label'>Müşteri *</label>
                                </div>
                                <div className='col-sm-10' style={{margin: '0 0 0 -4px', padding: '0 70px 0 35px'}}>
                                    <Select
                                        className="basic-single"
                                        classNamePrefix="select"
                                        placeholder="Müşteri Vkn/Tckn'si veya unvanı ile arama yapabilirsiniz"
                                        isClearable={true}
                                        isSearchable={true}
                                        name="customer"
                                        options={this.props.customers && this.props.customers}
                                        onChange={(e) => this.onChangeSelectedCustomer(e)}
                                        value={this.state.customerVknTckn}
                                    />
                                </div>
                            </div>}

                        <div className='col-sm-12 row'>
                            <div className='col-sm-6 row'>
                                <div className="col-sm-5">
                                    <label>Ad *</label>
                                </div>
                                <div className="col-sm-7">
                                    <div className={"form-group" + this.validateClass('tFirstName')}>
                                        <input className="form-control"
                                               type="text"
                                               name="firstName"
                                               id="tFirstName"
                                               data-vlength="1,255"
                                               onBlur={this.validateField}
                                               ref="tFirstName"
                                               value={this.state.user.firstName}
                                               onChange={(e) => this.onChangeUser(e)}/>
                                        {this.validateMessage('tFirstName') !== "" &&
                                            <UncontrolledTooltip placement="right" target="tFirstName" delay={0}>
                                                {this.validateMessage("tFirstName")}
                                            </UncontrolledTooltip>}
                                    </div>
                                </div>
                            </div>

                            <div className='col-sm-6 row'>
                                <div className="col-sm-5">
                                    <label>Soyad *</label>
                                </div>
                                <div className="col-sm-7">
                                    <div className={"form-group" + this.validateClass('tLastName')}>
                                        <input className="form-control"
                                               type="text"
                                               name="lastName"
                                               id="tLastName"
                                               data-vlength="1,255"
                                               onBlur={this.validateField}
                                               ref="tLastName"
                                               value={this.state.user.lastName}
                                               onChange={(e) => this.onChangeUser(e)}/>
                                        {this.validateMessage('tLastName') !== "" &&
                                            <UncontrolledTooltip placement="right" target="tLastName" delay={0}>
                                                {this.validateMessage("tLastName")}
                                            </UncontrolledTooltip>}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-sm-12 row'>
                            <div className='col-sm-6 row'>
                                <div className="col-sm-5">
                                    <label>Kullanıcı Adı *</label>
                                </div>
                                <div className="col-sm-7">
                                    <div className={"form-group" + this.validateClass('tUserName')}>
                                        <input className="form-control"
                                               type="text"
                                               name="username"
                                               id="tUserName"
                                               data-vdata="blockTurkishSpecialCh"
                                               data-vlength="1,20"
                                               onBlur={(e) => this.onUsernameBlur(e)}
                                               ref="tUserName"
                                               value={this.state.user.username}
                                               onChange={(e) => this.onChangeUser(e)}/>
                                        {this.validateMessage('tUserName') !== "" &&
                                            <UncontrolledTooltip placement="right" target="tUserName" delay={0}>
                                                {this.validateMessage("tUserName")}
                                            </UncontrolledTooltip>}
                                    </div>
                                </div>
                            </div>

                            <div className='col-sm-6 row'>
                                <div className="col-sm-5">
                                    <label>e-Posta *</label>
                                </div>
                                <div className="col-sm-7">
                                    <div className={"form-group" + this.validateClass('tEmail')}>
                                        <MaskedInput className="form-control"
                                                     type="text"
                                                     mask={emailMask}
                                                     name="email"
                                                     inputProps={{vdata: "email", vlength: '1,255'}}
                                                     id="tEmail"
                                                     onBlur={() => this.validateField({
                                                         target: {
                                                             id: "tEmail",
                                                             dataset: {vdata: "email", vlength: '1,255'},
                                                             value: this.state.user.email
                                                         }
                                                     })}
                                                     placeholder="_________@______.___"
                                                     ref="tEmail"
                                                     value={this.state.user.email}
                                                     onChange={(e) => this.onChangeUser(e)}/>
                                        {this.validateMessage('tEmail') !== "" &&
                                            <UncontrolledTooltip placement="right" target="tEmail" delay={0}>
                                                {this.validateMessage("tEmail")}
                                            </UncontrolledTooltip>}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-sm-12 row' style={{marginTop: '20px'}}>
                            <div className='col-sm-6 row'>
                                <div className='col-sm-5'>
                                    <label className="col-form-label">Yetki Grubu </label>
                                </div>
                                <div className='col-sm-7'>
                                    <div
                                        className={(!this.state.user.admin) ? "form-group" + this.validateClass('tRole') : "form-group"}>
                                        <Select
                                            clearable={false}
                                            className="select-control"
                                            name="role"
                                            id="tRole"
                                            disabled={this.state.user.admin}
                                            onBlur={!this.state.user.admin ? () => this.validateField({
                                                target: {
                                                    id: "tRole",
                                                    dataset: {vdata: "required"},
                                                    value: this.state.user.admin ? null : this.state.selectedRole
                                                }
                                            }) : null}
                                            inputProps={{'vdata': "required", 'vlength': "1,45"}}
                                            ref={!this.state.user.admin ? "tRole" : null}
                                            placeholder={this.state.user.admin ? "Admin Kullanıcı" : "Seçiniz..."}
                                            style={this.selectStyle('tRole')}
                                            value={this.state.user.admin ? null : this.state.selectedRole}
                                            onChange={(e) => this.onRoleChange(e)}
                                            options={this.state.authRoles.map(ar => ({
                                                value: ar.recordId,
                                                label: ar.roleName
                                            }))}
                                        />
                                        {(!this.state.user.admin && this.validateMessage('tRole') !== "") &&
                                            <UncontrolledTooltip placement="right" target="tRole"
                                                                 delay={0}>
                                                {this.validateMessage("tRole")}
                                            </UncontrolledTooltip>}
                                    </div>
                                </div>

                                <div className='col-sm-5'>
                                    <label className="col-form-label">Taslak Filigranı Eklensin?</label>
                                </div>
                                <div className='col-sm-7'>
                                    <input type="checkbox" checked={this.state.user.addDraftWatermark}
                                           onChange={this.onAddDraftWatermarkChange}/>
                                </div>
                            </div>

                            <div className='col-sm-6 row'>
                                <div className='col-sm-5'>
                                    <label className="col-form-label">Admin Kullanıcı </label>
                                </div>
                                <div className='col-sm-7'>
                                    <input type="checkbox" checked={this.state.user.admin}
                                           onChange={this.onCheckAdmin}/>
                                </div>

                                <div className='col-sm-5'>
                                    <label className="col-form-label">Aktif Kullanıcı </label>
                                </div>
                                <div className='col-sm-7'>
                                    <input type="checkbox" checked={this.state.user.active}
                                           onChange={this.onCheckActive}/>
                                </div>
                            </div>

                            {!this.state.user.admin &&
                                <div className='col-sm-6 row'>
                                    <div className='col-sm-5'>
                                        <label className="col-form-label">Kendi Ön Eklerini Kullansın</label>
                                    </div>
                                    <div className='col-sm-7'>
                                        <input type="checkbox" checked={this.state.user.hasPrefixCode}
                                               onChange={this.onHasPrefixCodeChange}/>
                                    </div>
                                </div>
                            }
                            {!this.state.user.admin &&
                                <div className='col-sm-6 row'>
                                    <div className='col-sm-5'>
                                        <label className="col-form-label">Kendi XSLT'lerini Kullansın</label>
                                    </div>
                                    <div className='col-sm-7'>
                                        <input type="checkbox" checked={this.state.user.hasXslt}
                                               onChange={this.onHasXsltChange}/>
                                    </div>
                                </div>
                            }

                            {!this.state.user.admin &&
                                <div className='col-sm-6 row'>
                                    <div className='col-sm-5'>
                                        <label className="col-form-label">Kendi Dokümanlarını Görsün</label>
                                    </div>
                                    <div className='col-sm-7'>
                                        <input type="checkbox" checked={this.state.user.showOwnDocuments}
                                               onChange={this.onShowOwnDocumentsChange}/>
                                    </div>
                                </div>
                            }
                            {(!this.state.user.admin && showOwnInbox(EntegratorConf.identifier, this.props.currentUser)) &&
                                <div className='col-sm-6 row'>
                                    <div className='col-sm-5'>
                                        <label className="col-form-label">Kendine Atanan Gelen Faturaları Görsün</label>
                                    </div>
                                    <div className='col-sm-7'>
                                        <input type="checkbox" checked={this.state.user.showAssignInbox}
                                               onChange={this.onShowAssignInbox}/>
                                    </div>
                                </div>
                            }

                            {showOnlySmart(EntegratorConf.identifier) &&
                                <div className='col-sm-6 row'>
                                    <div className='col-sm-5'>
                                        <label className="col-form-label">KDV Dahil ve KDV Hariç Değerleri Görsün</label>
                                    </div>
                                    <div className='col-sm-7'>
                                        <input type="checkbox"
                                               checked={this.state.user.showVatProccessing}
                                               onChange={this.onShowVatProccesing}/>
                                    </div>
                                </div>}
                        </div>
                    </div>
                </div>

                <div className="col-sm-12"
                     style={isMobile ? {display: 'flex', justifyContent: 'center', marginBottom: '5px'} : {}}>
                    <Nav pills className="nav-pills-primary ">
                        <NavItem>
                            <NavLink
                                className={classnames({active: this.state.activeTab === '1'})}
                                onClick={() => {
                                    this.toggle('1');
                                }}
                            >
                                Şube Bilgileri
                            </NavLink>
                        </NavItem>

                        <NavItem>
                            <NavLink
                                className={classnames({active: this.state.activeTab === '2'})}
                                onClick={() => {
                                    this.toggle('2');
                                }}
                            >
                                Etiket Bilgileri
                            </NavLink>
                        </NavItem>
                        {!this.state.user.admin && !!this.state.user.hasPrefixCode && this.state.user.hasPrefixCode &&
                            <NavItem>
                                <NavLink
                                    className={classnames({active: this.state.activeTab === '3'})}
                                    onClick={() => {
                                        this.toggle('3');
                                    }}
                                >
                                    Belge Ön Eki Bilgileri
                                </NavLink>
                            </NavItem>
                        }
                    </Nav>
                </div>

                <div className="col-sm-12">
                    <TabContent activeTab={this.state.activeTab}>
                        <TabPane tabId="1">
                            {customerBranchList.numberOfElements > 0 &&
                                <Row>
                                    <Col sm="12">
                                        <div className='card-header'>
                                            <h6 className='card-title'
                                                style={{marginBottom: '5px', marginTop: '20px'}}>
                                                {"Kullanıcı için şube(ler) seçiniz".toLocaleUpperCase('tr-TR')}
                                            </h6>
                                        </div>

                                        <div className='col-sm-12'>
                                            <Table columns={columns}
                                                   loading={this.state.loading}
                                                   loadingText="Kayıtlar getiriliyor..."
                                                   content={customerBranchList.content}
                                                   total={customerBranchList.totalElements}
                                                   page={this.state.page}
                                                   manual={this.state.manual}
                                                   size={this.state.size}
                                                   options={["5", "10", "20"]}
                                                   fetchData={this.fetchBranchListForC}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            }
                            <Row>
                                {customerBranchListForEdit.length > 0 &&
                                    <Col sm="12">
                                        <div className='col-sm-12'>
                                            <Table columns={columnsForEdit}
                                                   loading={this.state.loading}
                                                   loadingText="Kayıtlar getiriliyor..."
                                                   content={customerBranchListForEdit}
                                                   total={customerBranchListForEdit.length}
                                                   page={this.state.page}
                                                   manual={this.state.manual}
                                                   size={this.state.size}
                                                   options={["5", "10", "20", "50"]}
                                                   paginationEnabled={false}
                                            />
                                        </div>
                                    </Col>
                                }
                                {this.state.customerBranchListForAdding &&
                                    <Col sm="12">

                                        <div className='card-header'>
                                            <h6 className='card-title' style={{ marginTop: '20px' }}>
                                                {"Eklemek istediğiniz şubeyi seçiniz".toLocaleUpperCase('tr-TR')}
                                            </h6>
                                        </div>

                                        <div style={{paddingTop: '20px'}} className='col-sm-12'>
                                            <Table columns={columnsForEdit}
                                                   loading={this.state.loading}
                                                   loadingText="Kayıtlar getiriliyor..."
                                                   content={this.state.customerBranchListForAdding}
                                                   total={this.state.customerBranchListForAdding.length}
                                                   page={this.state.page}
                                                   manual={this.state.manual}
                                                   size={this.state.size}
                                                   options={["5", "10", "20", "50"]}
                                                   paginationEnabled={false}
                                            />
                                        </div>
                                    </Col>}
                            </Row>

                        </TabPane>

                        <TabPane tabId="2">
                            <Row>
                                <Col sm="12">
                                    <div className='card-header'>
                                        <h6 className='card-title' style={{ marginBottom: '5px', marginTop: '20px' }}>
                                            {"Kullanıcı için etiket(ler) seçiniz".toLocaleUpperCase('tr-TR')}
                                        </h6>

                                    </div>

                                    <div className='col-sm-12 mb-4'>
                                        <Select
                                            className="select-control"
                                            name="alias"
                                            id="tAlias"
                                            multi={true}
                                            ref="tAlias"
                                            placeholder="Seçiniz..."
                                            value={this.state.selectedAliasList}
                                            onChange={(e, value) => e && this.onAliasChange(e, value)}
                                            options={this.state.aliasList}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </TabPane>

                        {!this.state.user.admin && !!this.state.user.hasPrefixCode && this.state.user.hasPrefixCode &&
                            <TabPane tabId="3">
                                <Row>
                                    <Col sm="12">
                                        <div className='card-header'>
                                            <h6 className='card-title'
                                                style={{marginBottom: '5px', marginTop: '20px'}}>Kullanıcı için
                                                belge ön ekini(lerini) seçiniz</h6>
                                        </div>

                                        <div className='col-sm-12'>
                                            <Select
                                                className="select-control"
                                                name="prefixCodes"
                                                id="tPrefixCodes"
                                                multi={true}
                                                ref="tPrefixCodes"
                                                placeholder="Seçiniz..."
                                                value={!!this.state.selectedPrefixCodes && this.state.selectedPrefixCodes}
                                                onChange={(e, value) => e && this.onPrefixCodeChange(e, value)}
                                                options={this.state.prefixCodes}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            </TabPane>
                        }
                    </TabContent>
                </div>

                <div className={isMobile ? "" : "modal-footer"}>
                    <div className={isMobile ? "row w-100 p-0 ml-0" : 'col-sm-12 row'}>
                        <div className='col-3'>
                            <button type="button" data-toggle="tooltip" data-placement="bottom"
                                    style={{background: '#9e9e9e', padding: '10px 54px 10px 23px'}}
                                    rel="tooltip" className="TekBtn vazgec "
                                    onClick={this.cancelProcess}>
                                İptal
                            </button>
                        </div>
                        <div className="col-6"></div>
                        <div className='col-3'>
                            <button type="button" data-toggle="tooltip" data-placement="bottom"
                                    style={{
                                        background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
                                        float: 'right', padding: '10px 54px 10px 23px'
                                    }}
                                    rel="tooltip" className="TekBtn kaydet"
                                    onClick={() => this.saveUser()}>{this.state.mode === 'create' ? 'Onayla' : 'Kaydet'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default UserForm;
